<template>
  <div v-frag>
    <CardIeaAppMain ocultar-header-mobile class="examen-no-copy" colorCard="#A7BA38" oncontextmenu="return false;" onmousedown="return false;"
      onselectstart="return false;" oncopy="return false;" oncut="return false;">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" v-if="examen">
        <v-expansion-panels flat style="display: none">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h2>
                <CountDown @siguientePregunta="tiempoExamenAgotado()" :testFinalizado="testFinalizado"
                  :seconds="tiempoRespuesta" />
              </h2>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-sheet class="black--text">{{ descripcion }}</v-sheet>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card elevation="11" outlined shaped>
          <div class="d-flex justify-end px-4 px-md-8 pt-4" v-if="finRevision">
            <v-chip large outlined label :color="segundosRevision <= 30 ? 'error' : 'grey darken-2'">
              <v-icon left>mdi-timer-outline</v-icon>
              Tiempo de revisión: {{ relojRevisionTexto }}
            </v-chip>
          </div>
          <div class="d-flex justify-end px-4 px-md-8 pt-4" v-else-if="minutosPorPregunta">
            <v-chip large outlined label :color="segundosPregunta <= 30 ? 'error' : 'grey darken-2'">
              <v-icon left>mdi-timer-outline</v-icon>
              Tiempo para esta pregunta: {{ relojPreguntaTexto }}
            </v-chip>
          </div>
          <v-card-title class="px-4 px-md-8 pb-2 titulo-pregunta">{{ preguntaActual.pregunta }}
          </v-card-title>
          <v-card-text ref="altsExamen" class="px-4 px-md-8 pb-0 alternativas-ocultas" :class="claseModo">
            <v-container fluid class="pa-0" v-if="monoOptions == false">
              <v-col cols="12" sm="6" md="6" class="px-0 py-1" v-for="respuesta in respuestasOpciones" :key="respuesta.id">
                <div class="alternativa" :class="{ 'alternativa-visible': alternativaVisible === respuesta.id }"
                  @click.capture="tocarAlternativa($event, respuesta.id, () => (respuesta.seleccionada = !respuesta.seleccionada))">
                  <v-checkbox v-model="respuesta.seleccionada" color="primary" hide-details>
                    <template v-slot:label>
                      <div>
                        <strong>{{ respuesta.respuesta }}</strong>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
              </v-col>
            </v-container>
            <v-container fluid class="pa-0" v-else>
              <v-col cols="12" sm="6" md="6" class="px-0 py-1">
                <v-radio-group v-model="selected" class="mt-0" hide-details>
                  <div v-for="respuesta in respuestasOpciones" :key="respuesta.id" class="alternativa"
                    :class="{ 'alternativa-visible': alternativaVisible === respuesta.id }"
                    @click.capture="tocarAlternativa($event, respuesta.id, () => (selected = respuesta.id))">
                    <v-radio :label="`${respuesta.respuesta}`" :value="respuesta.id"></v-radio>
                  </div>
                </v-radio-group>
              </v-col>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 px-md-8 pt-3 pb-6">
            <div>
              <v-btn color="primary" elevation="7" large v-if="finRevision" @click="volverARevision()">
                <span>Volver a la revisión</span>
              </v-btn>

              <v-btn color="primary" elevation="7" large v-else-if="this.preguntas.length - 1 == this.indicePreguntaActual"
                @click="pregunta(1, true)">
                <span>Terminar Examen</span>
              </v-btn>

              <v-btn color="primary" elevation="7" large v-else-if="this.preguntas.length >= this.indicePreguntaActual"
                @click="pregunta(1)">
                <span>Siguiente</span>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12" v-else>
        <div v-if="tipo == 'Examen Final'">
          <div class="pl-16 mb-10 d-flex justify-center">
            <h3>Estimado alumno<br /></h3>
          </div>

          <div class="pl-16 mb-10 d-flex justify-center" v-if="!minutosPorPregunta">
            <ul>
              <!--<li>
                Recuerde que el examen <b>NO</b> puede ser enviado incompleto.
              </li>
              -->
              <li>
                El tiempo para presentar el examen es de
                <b>{{ tiempo_examen }} minutos</b>.
              </li>
            </ul>
          </div>
        </div>

        <v-alert type="warning" outlined prominent icon="mdi-timer-outline" class="mx-auto mb-10" max-width="700"
          v-if="minutosPorPregunta">
          Este examen tiene <b>tiempo límite por pregunta</b>: <b>{{ minutosPorPregunta }} minuto(s)</b> para cada una.
          Cuando se acaba el tiempo pasa sola a la siguiente pregunta y <b>no se puede volver</b> a preguntas anteriores.
          Al final tenés <b>{{ minutosRevision }} minutos de revisión</b> para corregir cualquier pregunta.
        </v-alert>

        <v-alert type="error" outlined prominent icon="mdi-alert-octagon-outline" class="mx-auto mb-10" max-width="700"
          v-if="tipo == 'Examen Final'">
          <b>NO</b> debe cerrar la sesión antes de presionar el botón <b>ENVIAR</b>, sino su examen quedará anulado.
        </v-alert>

        <!-- Pregunta de ejemplo: no se guarda ni corre el tiempo (el CountDown
             recien se monta al empezar). Sirve para practicar la modalidad. -->
        <v-card elevation="3" outlined class="mx-auto mb-10" max-width="700">
          <v-card-title>Nueva modalidad de examen</v-card-title>
          <v-card-text>
            <p>
              Para <b>prevenir el plagio</b>, las alternativas de cada pregunta
              aparecen <b>tapadas</b>. Así se evita que se puedan copiar o
              fotografiar todas las respuestas juntas.
            </p>
            <ul class="mb-4" v-if="modoTactil">
              <li><b>Un toque</b> sobre una alternativa la muestra; <b>otro toque</b> la vuelve a tapar.</li>
              <li>Solo se ve <b>una alternativa a la vez</b>.</li>
              <li><b>Dos toques seguidos</b> marcan la alternativa.</li>
            </ul>
            <p v-else>
              Para leer una alternativa, <b>pasá el mouse</b> por encima: solo se ve la
              que estás señalando. Hacé <b>clic</b> para marcarla.
            </p>
            <p class="mb-0">
              Antes de empezar, respondé esta <b>pregunta de ejemplo</b>. Es solo
              para practicar: <b>no afecta tu puntaje final</b> del examen.
            </p>
          </v-card-text>
          <v-card-title class="pt-0">¿Cuánto es 1 + 1?</v-card-title>
          <v-card-text ref="altsEjemplo" class="alternativas-ocultas" :class="claseModo">
            <v-radio-group v-model="ejemploSeleccion" hide-details>
              <div v-for="opcion in ejemploOpciones" :key="opcion" class="alternativa"
                :class="{ 'alternativa-visible': alternativaVisible === 'ejemplo-' + opcion }"
                @click.capture="tocarAlternativa($event, 'ejemplo-' + opcion, () => (ejemploSeleccion = opcion))">
                <v-radio :label="opcion" :value="opcion"></v-radio>
              </div>
            </v-radio-group>
            <p class="mt-4 mb-0 success--text" v-if="ejemploSeleccion === '2'">
              ¡Correcto! Ya podés empezar el examen.
            </p>
            <p class="mt-4 mb-0 error--text" v-else-if="ejemploSeleccion">
              Respuesta incorrecta, probá de nuevo.
            </p>
          </v-card-text>
        </v-card>

        <div class="pl-16 mb-10 d-flex justify-center">
          <v-btn color="success" elevation="7" large :loading="cargandoExamen" :disabled="cargandoExamen || ejemploSeleccion !== '2'" v-on:click="examen = true"
            @click="pregunta()">Empezar</v-btn>
        </div>
      </v-col>


      <v-row justify="center">
        <v-dialog v-model="dialog" persistent scrollable :max-width="$vuetify.breakpoint.mdAndUp ? 1100 : 610">
          <v-card>
            <v-card-title class="headline" onselectstart="return false;" oncontextmenu="return false;">
              Revisión del examen
            </v-card-title>
            <div class="px-6 pb-2">
              <v-alert type="warning" dense text class="mb-0">
                Presioná <b>Finalizar y enviar examen</b> para enviar tus respuestas.
                Si no lo hacés, el examen se enviará automáticamente al terminar el tiempo de revisión.
              </v-alert>
            </div>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
              <div class="d-flex flex-wrap align-center mb-2">
                <v-chip outlined label :color="segundosRevision <= 30 ? 'error' : 'grey darken-2'" class="mr-2 mb-2">
                  <v-icon left>mdi-timer-outline</v-icon>
                  Tiempo de revisión: {{ relojRevisionTexto }}
                </v-chip>
                <v-chip v-if="preguntasSinResponder" color="error" outlined class="mb-2">
                  {{ preguntasSinResponder }} pregunta(s) sin responder
                </v-chip>
              </div>
              <p>Hacé clic en una pregunta para ir a corregirla.</p>
              <!-- Desktop: 2 columnas para ver mas preguntas sin scrollear. -->
              <v-row dense>
                <v-col cols="12" md="6" v-for="(item, index) in datosRespuestas" :key="index">
                  <v-card outlined class="fill-height"
                    :class="{ 'pregunta-sin-responder': !item.respuestasSeleccionadas.length }"
                    @click="irAPregunta(index)"
                    onselectstart="return false;" oncontextmenu="return false;">
                    <v-card-title class="subtitle-1 font-weight-bold pb-1 titulo-pregunta">
                      {{ index + 1 }}. {{ item.pregunta.pregunta }}
                      <v-chip v-if="!item.respuestasSeleccionadas.length" x-small color="error" class="ml-2">
                        Sin responder
                      </v-chip>
                    </v-card-title>
                    <v-card-text class="pb-3">
                      <ul v-if="item.respuestasSeleccionadas.length">
                        <template v-for="respuesta in item.opcionesRespuestas">
                          <li v-if="respuesta.seleccionada == true" :key="respuesta.id">{{ respuesta.respuesta }}</li>
                        </template>
                      </ul>
                      <span v-else class="error--text">No marcaste ninguna alternativa.</span>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions class="pa-4">
              <v-btn color="success" :x-large="$vuetify.breakpoint.mdAndUp" :large="$vuetify.breakpoint.smAndDown" block elevation="6" class="font-weight-bold btn-enviar-examen"
                :loading="enviandoResultado" @click="guardarResultado()">
                <v-icon left>mdi-check-circle</v-icon>
                Finalizar y enviar examen
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </CardIeaAppMain>


  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import CountDown from "../../components/CountDown";

export default {
  name: "examen",
  components: {
    CardIeaAppMain,
    CountDown,
  },
  data() {
    return {
      ex4: ["primary"],
      test: "Prueba del titulo del test",
      descripcion: "esta es una descripcion provicional",
      preguntas: {},
      examen: false,
      indicePreguntaActual: 0,
      preguntaActual: {},
      respuestasOpciones: {},
      tiempoRespuesta: null,
      monoOptions: false,
      radioGroup: 1,
      selected: null,
      resp: {},
      dialog: false,
      testFinalizado: false,
      datosRespuestas: [],
      idTest: null,
      idExamen: null,
      validar: false,
      alumnoTest_id: null,
      tipo: null,
      tiempo_examen: null,
      cantidadPreguntas: null,
      enviandoResultado: false,
      minutosPorPregunta: null,
      minutosRevision: 5,
      cargandoExamen: true, // Empezar queda deshabilitado hasta que responde select-v2
      segundosPregunta: 0,
      relojPregunta: null,
      segundosRevision: 0,
      finRevision: null,
      ejemploSeleccion: null,
      ejemploOpciones: ["3", "2", "11", "0"],
      // Sin mouse real (celular/tablet) las alternativas se ven con toques en vez de hover.
      modoTactil: !window.matchMedia("(hover: hover) and (pointer: fine)").matches,
      alternativaVisible: null,
      ultimoToque: { id: null, t: 0 },
    };
  },
  mounted() {
    this.activarBloqueoCopia();
    this.$nextTick(this.igualarAltoAlternativas);
    window.addEventListener("resize", this.igualarAltoAlternativas);
    // La fuente web llega tarde en movil y cambia los renglones: remedir.
    if (document.fonts) document.fonts.ready.then(this.igualarAltoAlternativas);
    if (this.$store.getters.user.borrado == 1 || this.$store.getters.user.alumno_mora == true || this.$store.getters.user.excedente) {
      this.$router.push({
        name: "Home"
      });
    }
    this.test = "Prueba";
    this.idtest = this.$route.params.test;
    this.idExamen = this.$route.params.examen;
    this.$API
      .get({
        url:
          "pyr-preguntas/select-v2/" +
          this.idtest +
          "/" +
          this.$store.getters.user.IDStB +
          "/" +
          this.idExamen,
        data: {},
      })
      .then((res) => {
        this.tipo = res.tipo;
        this.cantidadPreguntas = res.questions.length;
        this.preguntas = res.questions;
        this.alumnoTest_id = res.alumnoRegistrado.id;
        this.tiempo_examen = res.total_evaluacion;
        this.minutosPorPregunta = Number(res.minutos_por_pregunta) || null;
        this.minutosRevision = Number(res.minutos_revision) || 5;
        this.cargandoExamen = false;
        let d = new Date("0001-01-01T" + res.total_evaluacion);
        console.log(d);
        //let minutos = d.getHours() * 60 + d.getMinutes();
        this.tiempoRespuesta = res.total_evaluacion * 60;
      })
      .catch(() => {
        this.$router.push({
          name: "Home",
        });
      });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.igualarAltoAlternativas);
    this.desactivarBloqueoCopia();
    this.detenerRelojPregunta();
  },
  // Tras cada render (nueva pregunta, ejemplo -> examen, modal): el DOM ya
  // esta pintado. ponytail: corre tambien con cada tick de los relojes; son
  // pocas alternativas, medir es barato.
  updated() {
    this.igualarAltoAlternativas();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    relojPreguntaTexto() {
      const m = Math.floor(this.segundosPregunta / 60);
      const s = this.segundosPregunta % 60;
      return m + ":" + String(s).padStart(2, "0");
    },
    relojRevisionTexto() {
      const m = Math.floor(this.segundosRevision / 60);
      const s = this.segundosRevision % 60;
      return m + ":" + String(s).padStart(2, "0");
    },
    preguntasSinResponder() {
      return this.datosRespuestas.filter((r) => !r.respuestasSeleccionadas.length).length;
    },
    claseModo() {
      return this.modoTactil ? "modo-tactil" : "modo-hover";
    },
  },
  methods: {
    // Todas las alternativas tapadas miden lo mismo que la mas alta, asi el
    // tamano no delata el largo del texto y no hay salto al destaparlas.
    igualarAltoAlternativas() {
      // Refs y no this.$el: con v-frag en la raiz, $el no contiene el contenido.
      [this.$refs.altsExamen, this.$refs.altsEjemplo].forEach((ref) => {
        const bloque = ref && (ref.$el || ref);
        if (!bloque) return;
        const labels = bloque.querySelectorAll(".alternativa .v-label");
        let max = 0;
        labels.forEach((l) => {
          l.style.height = "auto";
          max = Math.max(max, l.offsetHeight);
        });
        labels.forEach((l) => (l.style.height = ""));
        if (max) bloque.style.setProperty("--alto-alternativa", max + "px");
      });
    },
    // Solo durante el examen: al salir de la vista se sacan los listeners.
    activarBloqueoCopia() {
      document.addEventListener("copy", this.bloquearEvento);
      document.addEventListener("cut", this.bloquearEvento);
      document.addEventListener("contextmenu", this.bloquearEvento);
      document.addEventListener("selectstart", this.bloquearEvento);
      document.addEventListener("keydown", this.bloquearAtajos);
    },
    desactivarBloqueoCopia() {
      document.removeEventListener("copy", this.bloquearEvento);
      document.removeEventListener("cut", this.bloquearEvento);
      document.removeEventListener("contextmenu", this.bloquearEvento);
      document.removeEventListener("selectstart", this.bloquearEvento);
      document.removeEventListener("keydown", this.bloquearAtajos);
    },
    bloquearEvento(e) {
      e.preventDefault();
    },
    bloquearAtajos(e) {
      const tecla = String(e.key || "").toLowerCase();
      const ctrl = e.ctrlKey || e.metaKey;
      const inspector =
        e.key === "F12" ||
        (ctrl && e.shiftKey && ["i", "j", "c"].indexOf(tecla) !== -1) ||
        (ctrl && ["u", "s", "p"].indexOf(tecla) !== -1);
      const copia = ctrl && ["c", "x", "a"].indexOf(tecla) !== -1;
      if (inspector || copia) {
        e.preventDefault();
      }
    },
    // Tactil: 1 toque muestra/oculta (una sola visible), 2 toques seguidos marcan.
    // Mouse y teclado siguen el camino normal de Vuetify. Tambien atiende toques
    // en equipos hibridos (laptop tactil) aunque el modo sea hover.
    tocarAlternativa(e, id, marcar) {
      if (e.detail === 0 || (!this.modoTactil && e.pointerType !== "touch")) return;
      // Captura: frena el click antes de que Vuetify/label marquen la opcion.
      e.preventDefault();
      e.stopPropagation();
      const ahora = Date.now();
      const doble = this.ultimoToque.id === id && ahora - this.ultimoToque.t < 350;
      this.ultimoToque = doble ? { id: null, t: 0 } : { id, t: ahora };
      if (doble) {
        this.alternativaVisible = id;
        marcar();
      } else {
        this.alternativaVisible = this.alternativaVisible === id ? null : id;
      }
    },
    pregunta(index = 0, ultimapregunta = false) {
      this.alternativaVisible = null;
      if (index != 0) {
        this.guardarRespuestas();
      }

      if (index == 0) {

        this.$API
          .post({
            url: "guardar-horaInicio-examen",
            data: {
              alumnoTest_id: this.alumnoTest_id,
            },
          })
          .then(() => {
            console.log('hora guardada correctamente')
          })
          .catch((err) => {
            console.log(err);
          });

      }


      if(ultimapregunta==false){
        this.indicePreguntaActual = index + this.indicePreguntaActual;
      }
      


      console.log('total ' + this.cantidadPreguntas, 'index ' + index, 'indiceActual ' + this.indicePreguntaActual);

      if (this.datosRespuestas[this.indicePreguntaActual] != null) {
        let respuestas = this.datosRespuestas[this.indicePreguntaActual];
        this.respuestasOpciones = respuestas.opcionesRespuestas;
        this.preguntaActual = this.preguntas[this.indicePreguntaActual];

        let selectMono = respuestas.respuestasSeleccionadas;
        this.selected = selectMono[0];
      } else if (this.preguntas.length > this.indicePreguntaActual) {
        this.preguntaActual = this.preguntas[this.indicePreguntaActual];
        this.preguntaActual.tipo == "Multi Option"
          ? (this.monoOptions = false)
          : (this.monoOptions = true);
          this.respuestasOpciones=this.preguntaActual.respuestas
        console.log(this.preguntaActual)
      //   this.$API
      //     .get({
      //       url: `pyr-pregunta/${this.preguntaActual.id}`,
      //       data: {},
      //     })
      //     .then((res) => {
      //       this.respuestasOpciones = res.respuestas;
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      } else {
        this.testFinalizado = true;
        this.tiempoRespuesta = 0;
        this.dialog = true;
      }


      if (ultimapregunta == true) {

        this.mostrarDialog();
        return;
      }

      this.iniciarRelojPregunta();
    },
    // Reloj por pregunta: se reinicia al mostrar cada pregunta. Se mide contra una
    // hora de fin (no restando 1 por tick) porque el navegador frena los
    // setInterval con la pestaña en segundo plano.
    iniciarRelojPregunta() {
      this.detenerRelojPregunta();
      if (!this.minutosPorPregunta || this.testFinalizado) return;
      const fin = Date.now() + this.minutosPorPregunta * 60000;
      const tick = () => {
        this.segundosPregunta = Math.max(0, Math.ceil((fin - Date.now()) / 1000));
        if (this.segundosPregunta > 0) return;
        this.detenerRelojPregunta();
        if (this.indicePreguntaActual >= this.preguntas.length - 1) {
          this.pregunta(1, true); // ultima: pasa a la revision, no envia directo
        } else {
          this.pregunta(1);
        }
      };
      tick();
      this.relojPregunta = setInterval(tick, 1000);
    },
    detenerRelojPregunta() {
      clearInterval(this.relojPregunta);
      this.relojPregunta = null;
    },
    guardarRespuestas() {
      if (this.preguntaActual.tipo == "Multi Option") {
        this.resp = {
          pregunta: this.preguntaActual,
          opcionesRespuestas: this.respuestasOpciones,
          respuestasSeleccionadas: this.respuestasOpciones
            .filter((respuesta) => respuesta.seleccionada == true)
            .map((r) => r.id),
        };
      } else {

        this.respuestasOpciones.forEach(element => {
          element.seleccionada = false
          if (element.id === this.selected) {
            element.seleccionada = true;
          }
        });

        this.resp = {
          pregunta: this.preguntaActual,
          opcionesRespuestas: this.respuestasOpciones,
          respuestasSeleccionadas: this.respuestasOpciones
            .filter((respuesta) => respuesta.id == this.selected)
            .map((r) => r.id),
        };
      }

      // $set: reactivo, para que el modal de revision refleje las correcciones.
      this.$set(this.datosRespuestas, this.indicePreguntaActual, this.resp);
      const parsed = JSON.stringify(this.datosRespuestas);
      localStorage.setItem("respu", parsed);
      this.resp = {};
      this.selected = null;
      return true;
    },

    guardarResultado() {
      // Frena el CountDown y evita mandar dos veces el mismo examen: si el POST
      // falla el .catch no navega a Home, y sin esta guarda el timer volvia a
      // llamar aca una y otra vez.
      this.testFinalizado = true;
      this.detenerRelojPregunta();
      if (this.enviandoResultado) return;
      this.enviandoResultado = true;

      // Con el modal de revision abierto la ultima pregunta ya se guardo; volver
      // a guardar con selected=null borraba la respuesta si era de opcion unica.
      if (!this.dialog) this.guardarRespuestas();

      this.$API
        .post({
          url: "guardar-respuestas",
          data: {
            respuestas: JSON.stringify(this.datosRespuestas),
            idExamen: this.idExamen,
            alumnoTest_id: this.alumnoTest_id,
          },
        })
        .then(() => {
          this.$API
            .post({
              url: "guardar-horaFin-examen",
              data: {
                alumnoTest_id: this.alumnoTest_id,
              },
            })
            .then(() => {
              console.log('hora guardada correctamente')
            })
            .catch((err) => {
              console.log(err);
            });

          this.dialog = false;
          this.$router.push({
            name: "Home",
          });
        })
        .catch((err) => {
          // Se libera para que el boton Finalizar pueda reintentar a mano; el
          // reenvio automatico ya quedo cortado por testFinalizado.
          this.enviandoResultado = false;
          console.log(err);
        });





    },

    // Revision de solo lectura: minutosRevision (test_details.minutos_revision); al vencer se envia solo.
    // Reusa relojPregunta para que detenerRelojPregunta tambien lo corte.
    mostrarDialog() {
      this.dialog = true;
      // Al volver de corregir una pregunta el reloj de revision sigue corriendo.
      if (this.finRevision) return;
      // testFinalizado frena el CountDown general: la revision siempre tiene
      // sus minutos completos aunque el tiempo del examen venza antes.
      this.testFinalizado = true;
      this.detenerRelojPregunta();
      this.finRevision = Date.now() + this.minutosRevision * 60000;
      const tick = () => {
        this.segundosRevision = Math.max(0, Math.ceil((this.finRevision - Date.now()) / 1000));
        if (this.segundosRevision > 0) return;
        // Si estaba corrigiendo una pregunta, guardarResultado la guarda antes de enviar.
        this.guardarResultado();
      };
      tick();
      this.relojPregunta = setInterval(tick, 1000);
    },
    // Desde la revision: abre la pregunta para corregirla, sin reloj por pregunta.
    irAPregunta(index) {
      if (this.enviandoResultado) return;
      const respuestas = this.datosRespuestas[index];
      this.indicePreguntaActual = index;
      this.preguntaActual = this.preguntas[index];
      this.monoOptions = this.preguntaActual.tipo != "Multi Option";
      this.respuestasOpciones = respuestas.opcionesRespuestas;
      this.selected = respuestas.respuestasSeleccionadas[0] || null;
      this.alternativaVisible = null;
      this.dialog = false;
    },
    // Se acabo el tiempo general: en vez de enviar, abre la revision.
    // Las preguntas que no llego a ver se agregan vacias para poder responderlas.
    tiempoExamenAgotado() {
      if (this.finRevision) return;
      this.guardarRespuestas();
      this.preguntas.forEach((p, i) => {
        if (!this.datosRespuestas[i]) {
          this.$set(this.datosRespuestas, i, {
            pregunta: p,
            opcionesRespuestas: p.respuestas,
            respuestasSeleccionadas: [],
          });
        }
      });
      this.mostrarDialog();
    },
    volverARevision() {
      this.guardarRespuestas();
      this.mostrarDialog();
    },
  },
};
</script>

<style>
/* En pantallas chicas el texto del boton no entra en una linea: que baje. */
.btn-enviar-examen.v-btn {
  height: auto !important;
  min-height: 44px;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.btn-enviar-examen .v-btn__content {
  white-space: normal;
  flex-shrink: 1;
}
/* v-card-title corta palabras a la mitad (break-all) por defecto. */
.titulo-pregunta {
  word-break: normal;
  line-height: 1.5;
}

/* Ni la copia ni el inspector se pueden bloquear de verdad desde el navegador
   (menu del navegador, ver-codigo-fuente, depuracion remota, JS desactivado).
   Esto solo encarece hacerlo mientras dura el examen. */
.examen-no-copy,
.examen-no-copy * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Alternativas ocultas: cada una queda tapada por un bloque de color.
   Con mouse el texto se ve con hover (o foco de teclado); tactil se ve con un
   toque (clase alternativa-visible, ver tocarAlternativa). */
.alternativas-ocultas .alternativa {
  margin-bottom: 8px;
}
.alternativas-ocultas .alternativa .v-label {
  flex: 1;
  /* Todas con el alto de la mas larga (--alto-alternativa, ver
     igualarAltoAlternativas): no se delata el largo ni salta al destaparse. */
  height: var(--alto-alternativa, 36px);
  min-height: 36px;
  overflow: hidden;
  padding: 6px 12px;
  border-radius: 4px;
  background-color: #bdbdbd;
  color: transparent;
  transition: background-color 0.15s, color 0.15s;
}
.alternativas-ocultas .alternativa-visible .v-label,
.modo-hover .alternativa:hover .v-label,
.modo-hover .alternativa:focus-within .v-label {
  /* Destapada nunca recorta: como minimo el alto comun, y si el texto
     necesita mas (medicion vieja), crece. */
  height: auto;
  min-height: var(--alto-alternativa, 36px);
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.87);
}
.pregunta-sin-responder {
  background-color: #ffebee !important;
  border-left: 4px solid #e53935;
}
/* Sin zoom por doble toque: el doble toque marca la alternativa. */
.modo-tactil .alternativa {
  touch-action: manipulation;
}
</style>
